import { render } from "./PopupTable.vue?vue&type=template&id=4413c901"
import script from "./PopupTable.vue?vue&type=script&lang=ts"
export * from "./PopupTable.vue?vue&type=script&lang=ts"
script.render = render

export default script